import { h } from "preact";
import { FormattedMessage } from 'react-intl';

import ChatIcon from 'images/ChatIcon.svg';

import { HOST_WEB_PRODUCTION, HOST_WEB_STAGING } from 'utils/constants';
import { lawyers } from 'utils/lawyers';
import { shuffle } from 'utils/shuffle';

import PremiumAd from 'containers/PremiumAd';

import Button from 'components/Button'
import Column from 'components/Column';
import ContainerAd from 'components/Container/ContainerAd';
import ContentAd from 'components/Content/ContentAd';
import Footer from 'components/Footer';
import H2 from 'components/H2';
import H3 from 'components/H3';
import Img from 'components/Img';
import P from 'components/P';
import PAd from 'components/P/PAd';
import Thumbnail from 'components/Thumbnail';
import ThumbnailDiv from 'components/Thumbnail/ThumbnailDiv';
import ThumbnailNumber from 'components/Thumbnail/ThumbnailNumber';
import ThumbnailWrapper from 'components/Thumbnail/ThumbnailWrapper';
import { color } from 'components/foundations';

import messages from './messages';

const HOST = process.env.PREACT_APP_API_URL === 'production' ? HOST_WEB_PRODUCTION : HOST_WEB_STAGING;

function onClickCTA(props) {
  const location = props.matches.location;
  const category = props.matches.category;
  const url = props.matches.url;
  const version = props.matches.version;
  const cohort = props.matches.cohort;

  if (location.includes("summary")) {
    return HOST + "/partner/klinik/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=chat&utm_content=intisari&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location === "ulasan-top") {
    return HOST + "/partner/klinik/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=chat&utm_content=ulasan1&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location == "ulasan-bottom") {
    return HOST + "/partner/klinik/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=chat&utm_content=ulasan2&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else {
    return HOST + "/partner/klinik/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=chat&utm_content=uncategorized&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  }
}

function getHeaderTitle(props) {
  const location = props.matches.location;
  const category = props.matches.category;

  switch (category) {
    case "Waris":
      return <FormattedMessage {...messages.header_waris} />

    case "Pesangon":
      return <FormattedMessage {...messages.header_pesangon} />

    case "Piutang":
      return <FormattedMessage {...messages.header_piutang} />

    default:
      if (location === "summary-top" || location === "ulasan-top") {
        return <FormattedMessage {...messages.header_top} />
      } else {
        return <FormattedMessage {...messages.header_bottom} />
      }
  }
}

function getHeaderDescription(props) {
  const location = props.matches.location;
  const category = props.matches.category;

  switch (category) {
    case "Waris":
      return <FormattedMessage {...messages.description_waris} />

    case "Pesangon":
      return <FormattedMessage {...messages.description_pesangon} />

    case "Piutang":
      return <FormattedMessage {...messages.description_piutang} />

    default:
      if (location === "summary-top" || location === "ulasan-top") {
        return <FormattedMessage {...messages.description_top} />
      } else {
        return <FormattedMessage {...messages.description_bottom} />
      }
  }
}

function HeaderTitle(props) {
  return (
    <div>
      <H2 style={{ margin: "0" }}>
        {getHeaderTitle(props)}
      </H2>
      <PAd>
        {getHeaderDescription(props)}
      </PAd>
    </div>
  )
}

function LawyerImage(props) {
  return (
    <ThumbnailWrapper data-testid="summary-lawyer-thumbnail">
      {shuffle(lawyers).slice(0, 3).map((lawyer, index) =>
        <ThumbnailDiv key={'lawyer' + index} zIndex={10 - index}>
          <Thumbnail src={lawyer} alt={`lawyer ${index}`} />
        </ThumbnailDiv>
      )}
      <ThumbnailDiv zIndex={6}>
        <ThumbnailNumber>60+</ThumbnailNumber>
      </ThumbnailDiv>
    </ThumbnailWrapper>
  )
}

function Price(props) {
  return (
    <div>
      <P style={{ color: color.text_black, margin: "0" }}>{"30 Menit Konsultasi via Chat"}</P>
      <H3 style={{ fontSize: '20px', margin: '0px', color: "#003366" }}>
        <span style={{ fontSize: '20px', fontWeight: '500', textDecoration: 'line-through', color: "#333333" }}>{"Rp50.000"}</span>
        {"  Rp30.000"}
      </H3>
    </div>
  )
}

const DefaultChatAds = (props) => {
  return (
    <ContainerAd>
      <ContentAd>
        <br />
        <HeaderTitle {...props} />
        <br />
        <LawyerImage {...props} />
        <Price {...props} />
        <Column width="2" style={{ margin: "0" }}>
          <Button
            href={onClickCTA(props)}
            blank="_blank"
            color='yellow'
            size="large"
          >
            <div style={{ display: "inline-block", width: "30px", marginRight: "10px" }}><Img alt="Chat Icon" src={ChatIcon} style={{ width: "20px" }} /></div>
            <FormattedMessage {...messages.cta} />
          </Button>
        </Column>
        <br />
        <Footer />
      </ContentAd>
    </ContainerAd>
  )
}

const ChatAds = (props) => {
  return <DefaultChatAds {...props} />
}

export default ChatAds;